import React, { type Dispatch, type SetStateAction } from 'react';
import CloseButton from '../../image/icons/map/ArrowBottom.svg';
import ReturnBackIcon from '../../image/icons/ReturnBackIcon.svg';
import { type Route } from '../../types/Forms';
import { type UnifiedItineraryDTO } from '../../types/Itinerary';

interface DetailModalProps {
  children: React.ReactNode;
  visible: boolean;
  setVisible: Dispatch<SetStateAction<boolean>>;
  setShowArrowTop: Dispatch<SetStateAction<boolean>>;
  setTripListHeight: Dispatch<SetStateAction<number>>;
  showArrowTop: boolean;
  setSelectedTrip: Dispatch<SetStateAction<UnifiedItineraryDTO | null>>;
  setAnimated: Dispatch<SetStateAction<boolean>>;
  ITakeMyCar: boolean;
  setITakeMyCar: Dispatch<SetStateAction<boolean>>;
  setSelectedItinerary: Dispatch<SetStateAction<string>>;
  setIsMerge: Dispatch<SetStateAction<boolean>>;
  setItineraries: Dispatch<SetStateAction<Route[]>>;
  setGoItineraries: Dispatch<SetStateAction<Route[]>>;
  setBackupReturnItineraries: Dispatch<SetStateAction<Route[]>>;
  handleResetMap: () => void;
}

const DetailModal: React.FC<DetailModalProps> = ({
  children,
  visible,
  setVisible,
  setShowArrowTop,
  showArrowTop,
  setTripListHeight,
  setSelectedTrip,
  setAnimated,
  ITakeMyCar,
  setITakeMyCar,
  setSelectedItinerary,
  setIsMerge,
  setItineraries,
  setGoItineraries,
  setBackupReturnItineraries,
  handleResetMap
}) => {
  // if (!visible) return null;

  return (
    <div className={`shadow-top rounded-t-2xl w-full backdrop-blur-sm bg-white/45 ${!visible && 'hidden'}`} id="detailModal">
      <div>
        <div className={`relative w-full pt-1 flex items-center ${!ITakeMyCar && !showArrowTop ? 'justify-center' : 'justify-start'}`}>
          {showArrowTop && !ITakeMyCar ? (
            <button
              className="ml-3 mt-3"
              onClick={() => {
                setTripListHeight(50);
                setShowArrowTop(false);
                setSelectedTrip(null);
                setAnimated(false);
                handleResetMap();
              }}
            >
              <img src={ReturnBackIcon} className="w-[25px]" />
            </button>
          ) : !showArrowTop && !ITakeMyCar ? (
            <button
              className="mt-2"
              style={{ display: 'none' }}
              onClick={() => {
                setVisible(false);
                setAnimated(true);
              }}
            >
              <img src={CloseButton} className="w-[22px]" />
            </button>
          ) : (
            ITakeMyCar && (
              <button
                className="ml-3 mt-3"
                onClick={() => {
                  setITakeMyCar(false);
                  setSelectedItinerary('');
                  setTripListHeight(50);
                  setItineraries([]);
                  setGoItineraries([]);
                  setBackupReturnItineraries([]);
                  setSelectedItinerary('');
                }}
              >
                <img src={ReturnBackIcon} className="w-[25px]" />
              </button>
            )
          )}
        </div>
        {children}
      </div>
    </div>
  );
};

export default DetailModal;
